import { getImpersonationToken } from "./impersonation";
import { getValidAccessToken } from "./tokenRefresh";

/**
 * The bearer token every authenticated request from this tab must carry.
 *
 * Prefers the tab-scoped impersonation token so the request acts as the target
 * user, and otherwise falls back to the admin's own access token, proactively
 * refreshed when it is close to expiry (a no-op for legacy sessions with no
 * refresh token).
 *
 * Every transport MUST resolve its token through this helper. When one
 * transport ignored impersonation (the raw `fetch` calls in `@/api/api`), a
 * single user action was split across two identities: the storage upload was
 * stamped with the admin's `uploadedById` while the follow-up REST write ran as
 * the impersonated user, so the backend's file-ownership check rejected the
 * caller's "own" upload with a 403.
 */
export const getRequestAuthToken = async (): Promise<string | null> =>
  getImpersonationToken() ?? (await getValidAccessToken());
